<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible')"
    :header="$t('features.issues.snoozed.snooze_issue')"
    modal
  >
    <Message v-if="success" severity="success" :closable="false">
      {{ $t('features.issues.snoozed.snoozed_success') }}
    </Message>

    <Message v-if="error" severity="error" :closable="false">
      {{ $t('global.error_generic') }}
    </Message>

    <div class="flex flex-row" style="width: 50rem">
      <div class="min-w-32 leading-9 mr-2 mb-2">
        {{ $t('features.issues.snoozed.snooze_for') }}
      </div>

      <Button
        v-for="(value, key) in presets"
        :key="'snooze-preset-' + key"
        @click="presetDateField(value)"
        :label="key"
        class="self-start mr-2"
        size="small"
      />
    </div>

    <div class="flex flex-row">
      <div class="min-w-32 leading-9 mr-2">
        {{ $t('glossary.snoozed_until') }}
      </div>
      <DatePicker
        v-model="snoozedUntilDate"
        :disabled="true"
        date-format="yy-mm-dd"
        :placeholder="$t('global.select_an_option')"
        class="mb-2"
        manual-input
      />
    </div>

    <template #footer>
      <Button severity="secondary" @click="cancelSnoozing">
        {{ $t('global.cancel') }}
      </Button>

      <Button @click="submit">
        {{ $t('global.ok') }}
      </Button>
    </template>
  </Dialog>
</template>

<script lang="ts">
import { addDays } from 'date-fns';
import type { PropType } from 'vue';
import MeterIssueApi from '@/data/meters/MeterIssueApi.ts';
import type { MeterIssueJson } from '@/data/meters/MeterIssueJson.ts';
import type { PlantJson } from '@/data/plants/PlantJson.ts';

export default {
  name: 'SnoozeIssueDialog',
  props: {
    visible: { type: Boolean, required: true },
    companyId: { type: Number, required: true },
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
    issue: { type: Object as PropType<MeterIssueJson>, required: true },
  },
  emits: ['fetch-required', 'update:visible'],
  data() {
    return {
      success: null,
      error: null,
      snoozedUntilDate: null as Date,
      dateState: null,
      presets: {
        '7 days': 7,
        '14 days': 14,
        '30 days': 30,
        '60 days': 60,
      },
    };
  },
  methods: {
    presetDateField(value: number): void {
      this.snoozedUntilDate = addDays(new Date(), value);
    },
    cancelSnoozing() {
      this.$emit('update:visible', false);
      this.dateState = true;
    },
    submit(event) {
      this.success = null;
      this.error = null;
      this.dateState = null;

      if (!this.snoozedUntilDate) {
        event.preventDefault();
        this.dateState = false;
      } else {
        new MeterIssueApi()
          .snooze(
            this.companyId,
            this.plantJson.id,
            this.issue.meter_id,
            this.issue.id,
            this.snoozedUntilDate,
          )
          .then(() => {
            this.success = true;
            setTimeout(() => {
              this.$emit('fetch-required');
            }, 2000);
          })
          .catch(() => {
            this.error = true;
          });
      }
    },
  },
};
</script>

<style scoped></style>
